var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#54708C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.95 1.464l2.828 2.829a1 1 0 0 1 0 1.414L11.95 8.536a1 1 0 0 1-1.414-1.415L11.656 6H6.829a3.001 3.001 0 1 1 0-2h4.827l-1.12-1.121a1 1 0 1 1 1.414-1.415zM4 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.95 7.963l2.828 2.828a1 1 0 0 1 0 1.415l-2.828 2.828a1 1 0 0 1-1.414-1.414l1.12-1.122h-4.827a3.001 3.001 0 1 1 0-2h4.827l-1.12-1.12a1 1 0 1 1 1.414-1.415zM8 10.498a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.95 14.464l2.828 2.829a1 1 0 0 1 0 1.414l-2.828 2.829a1 1 0 0 1-1.414-1.415L19.656 19h-4.827a3.001 3.001 0 1 1 0-2h4.827l-1.12-1.121a1 1 0 0 1 1.414-1.415zM12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupage);
export default __webpack_public_path__ + "static/media/groupage.7c212377c656165463a5d21e6e0de118.svg";
export { ForwardRef as ReactComponent };